import { Box } from "@seneca/senekit";

import { ProviderSSO } from "services/firebase/auth/types";

import { Props as SignUpFormButtonProps } from "./SignUpFormButton";

type Props = Pick<
  SignUpFormButtonProps,
  "signInWith" | "selectedProvider" | "signInWithRedirect"
> & { provider?: ProviderSSO; providerDisplayName?: string };

export default function StudienkreisSignUpFormButton({
  provider = "studienkreis",
  providerDisplayName = "Studienkreis",
  signInWith,
  selectedProvider,
  signInWithRedirect
}: Props) {
  return (
    <Box
      component="button"
      onClick={() => signInWith(provider, signInWithRedirect)}
      disabled={!!selectedProvider && selectedProvider !== provider}
      width="100%"
      height="100%"
      outline="none"
      border="none"
      boxShadow="none"
      padding="12"
      cursor="pointer"
      color="#FFF"
      background="#C10223"
      hoverStyles={{ background: "#8B142C", color: "#FFF" }}
    >
      {"Continue with " + providerDisplayName}
    </Box>
  );
}
